import {Component, OnInit} from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";

@Component({
    selector: 'app-actandstatutes',
    templateUrl: './actandstatutes.component.html',
    styleUrls: ['./actandstatutes.component.scss']
})
export class ActandstatutesComponent implements OnInit {

    constructor(
        private meta: Meta,
        private titles: Title
    ) {
    }

    ngOnInit(): void {
        window.scrollTo(0, 0);
        this.updateMetaTags();
    }

    updateMetaTags() {
        this.titles.setTitle('Understanding ARNI\'s Act & Statutes for Governance\n');
        this.meta.updateTag({
            name: 'description',
            content: `Explore ARNI's Act & Statutes that define its governance, principles, and structure. A foundation built on integrity, transparency, and excellence.`
        });
    }

}
